















import {mapGetters} from 'vuex';
import Vue, {PropType} from 'vue';
import {AdvertType} from '#/Advert';

export default Vue.extend({
  name: 'FilterSlider',

  props: {
    active: {
      type: Boolean as PropType<boolean>,
      required: true,
    },
    type: {
      type: Object as PropType<AdvertType>,
      default: null,
    },
  },

  computed: {
    ...mapGetters([
      'advertTypeItems',
    ]),
  },

  methods: {
    /**
     * recharge la page courante avec le filtre
     *
     * @param {AdvertType} selectedType
     */
    onSelectType(selectedType: AdvertType): Promise<void> {
      return new Promise((resolve, reject) => {
        this.$router.push({
          name: this.$route.name as string | undefined,
          query: {
            ...this.$route.query,
            types: `${selectedType.raw}`,
          },
        })
            .then(() => {
              resolve();
            })
            .catch(() => {
              reject();
            })
            .finally(() => {
              this.$emit('update:active', false);
            });
      });
    },
  },
});
